import { NUTRITIONAL_INFORMATION_SUBSET as H, NutrientClaimTypeCodes as N, AllergensContainmentCodes as P, AdditivesContainmentCodes as j, NutrientMeasurementPrecisions as T, PreparationStates as O } from "../types/types.js";
const x = {
  GRM: "g",
  KCAL: "kcal",
  KJ: "kJ",
  MC: "μg",
  MLT: "ml",
  MG: "mg"
}, V = Object.keys(
  H
), f = (t) => Object.keys(x).includes(t), Q = (t) => V.includes(t), Y = (t, c) => {
  if (t.length !== c.length)
    throw new Error("Arrays must be the same length");
  const o = {};
  for (let e = 0; e < t.length; e++) {
    const n = c[e], s = t[e];
    n && (o[n] ? o[n].push(s) : o[n] = [s]);
  }
  return o;
}, D = (t) => {
  const { all_descriptions: c, all_codes: o } = t.hierarchy.descriptions[0];
  if (!c || !o)
    throw new Error("Missing descriptions or codes");
  if ((c == null ? void 0 : c.length) !== (o == null ? void 0 : o.length))
    throw new Error("Descriptions and codes arrays must be of the same length");
  const e = new Map(
    o.map((s, a) => [
      `/tuotteet?kategoria=${s}`,
      c[a]
    ])
  );
  return ((s) => new Map(Array.from(s.entries()).slice(2)))(e);
}, G = (t, c, o) => t == null ? void 0 : t.fishings.map((e) => {
  var a;
  const n = (_) => {
    var l;
    return (l = _ == null ? void 0 : _.find(
      (u) => u.language === o || !_.some((m) => m.language === o) && u.language === "fi"
    )) == null ? void 0 : l.value;
  }, s = n(e == null ? void 0 : e.catch_areas) ? (a = n(e == null ? void 0 : e.catch_areas)) == null ? void 0 : a.split(";") : [];
  return [
    { key: c("fishing_name"), value: n(e == null ? void 0 : e.name) },
    { key: c("fishing_scientific_name"), value: e == null ? void 0 : e.scientific_name },
    { key: c("fishing_catch_area"), value: s },
    {
      key: c("fishing_catch_method"),
      value: n(e == null ? void 0 : e.catch_methods)
    },
    {
      key: c("fishing_catch_country"),
      value: n(e == null ? void 0 : e.catch_countries)
    },
    {
      key: c("fishing_prod_method"),
      value: n(e == null ? void 0 : e.production_method_for_fish_and_seafoods)
    },
    {
      key: c("fishing_storage_states"),
      value: n(e == null ? void 0 : e.storage_states)
    }
  ].filter((_) => {
    var l;
    return (l = _.value) == null ? void 0 : l.length;
  });
}), z = (t, c, o) => {
  const e = {};
  t.nutritional_claims.forEach((a) => {
    const _ = a.nutrient_claim_types.find(
      (u) => u.language === o && u.value || !a.nutrient_claim_types.some(
        (m) => m.language === o && m.value
      ) && u.language === "fi" && u.value
    ), l = a.nutritional_claim_nutrient_elements.find(
      (u) => u.language === (_ == null ? void 0 : _.language) && u.value
    );
    if (_ && l) {
      const u = _.code, m = _.value || "", E = l.value, v = l.code;
      if (E) {
        const d = c(`${u}-${v}`);
        d ? e.PREFORMATTED ? e.PREFORMATTED.push({
          value: d,
          containmentText: "",
          translationKey: `${u}-${v}`
        }) : e.PREFORMATTED = [
          {
            value: d,
            containmentText: "",
            translationKey: `${u}-${v}`
          }
        ] : e[u] ? e[u].push({
          value: E,
          containmentText: m,
          translationKey: `${u}-${v}`
        }) : e[u] = [
          {
            value: E,
            containmentText: m,
            translationKey: `${u}-${v}`
          }
        ];
      }
    }
  });
  const n = {};
  return [
    N.CONTAINS,
    N.HIGH,
    N.LOW,
    N.MAY_CONTAIN,
    N.GUARANTEED_FREE_FROM,
    N.FREE_FROM
  ].forEach((a) => {
    e[a] && (n[a] = e[a], delete e[a]);
  }), Object.keys(e).forEach((a) => {
    n[a] = e[a];
  }), n;
}, W = (t) => t.allergens.every(
  (o) => o.level_of_containments.every(
    (e) => e.code === "FREE_FROM"
  )
), C = (t, c) => {
  const o = {
    CONTAINS: [],
    MAY_CONTAIN: [],
    FREE_FROM: []
  };
  return t.allergens.forEach((e) => {
    var a;
    const n = e.level_of_containments.find(
      (_) => _.language === c || !e.level_of_containments.some(
        (l) => l.language === c
      ) && _.language === "fi"
    ), s = e.allergen_types.find(
      (_) => _.language === c || !e.allergen_types.some((l) => l.language === c) && _.language === "fi"
    );
    n && (n.code === P.CONTAINS || n.code === P.MAY_CONTAIN) && n.value && (s != null && s.value) && ((a = e.allergen_types[0]) != null && a.value) && o[n.code].push({
      value: s.value,
      containmentText: n.value
    });
  }), o;
}, X = (t, c) => {
  const o = {
    CONTAINS: [],
    MAY_CONTAIN: [],
    FREE_FROM: []
  };
  return t.e_numbers.forEach((e) => {
    var a, _;
    const n = (a = e.level_of_containments[0]) == null ? void 0 : a.code, s = (_ = e.level_of_containments[0]) == null ? void 0 : _.value;
    n === j.CONTAINS && s && e.e_numbers.filter(
      (l) => l.language === c || !e.e_numbers.some((u) => u.language === c) && l.language === "fi"
    ).forEach((l) => {
      l.value && o[n].push({
        value: `${l.code} ${l.value}`,
        containmentText: s
      });
    });
  }), o;
}, Z = (t, c) => {
  if (!(t != null && t.product_activities))
    return {};
  const o = (s, a) => {
    const _ = s.filter(
      (l) => l.language === a
    );
    return _.length > 0 ? _ : s.filter((l) => l.language === "fi");
  }, e = t.product_activities.flatMap(
    (s) => o(s.country_of_activities, c).map((a) => a.value)
  ), n = t.product_activities.flatMap(
    (s) => o(s.product_activities, c).map((a) => a.value)
  );
  return Y(
    e,
    n
  );
}, L = (t) => {
  var c;
  switch ((c = t.measurement_precisions[0]) == null ? void 0 : c.code) {
    case T.GREATER_THAN:
      return "> ";
    case T.GREATER_THAN_OR_EQUAL:
      return "≥ ";
    case T.LESS_THAN:
      return "< ";
    case T.LESS_THAN_OR_EQUAL:
      return "≤ ";
    default:
      return "";
  }
}, J = (t, c) => {
  var m, E, v, d, F, M, A, $, k, S, g, b, h, q, w, I;
  const o = t == null ? void 0 : t.filter(
    (y) => {
      var i;
      return (i = y.preparation_states) == null ? void 0 : i.some(
        (r) => r.code === O.PREPARED || r.code === O.UNSPECIFIED
      );
    }
  ), e = t == null ? void 0 : t.filter(
    (y) => {
      var i;
      return (i = y.preparation_states) == null ? void 0 : i.some(
        (r) => r.code === O.UNPREPARED
      );
    }
  ), n = o == null ? void 0 : o.find(
    (y) => {
      var i, r;
      return ((r = (i = y.nutrient_types) == null ? void 0 : i[0]) == null ? void 0 : r.code) === "ENERKJO";
    }
  ), s = e == null ? void 0 : e.find(
    (y) => {
      var i, r;
      return ((r = (i = y.nutrient_types) == null ? void 0 : i[0]) == null ? void 0 : r.code) === "ENERKJO";
    }
  ), a = o == null ? void 0 : o.find(
    (y) => {
      var i, r;
      return ((r = (i = y.nutrient_types) == null ? void 0 : i[0]) == null ? void 0 : r.code) === "ENER-";
    }
  ), _ = e == null ? void 0 : e.find(
    (y) => {
      var i, r;
      return ((r = (i = y.nutrient_types) == null ? void 0 : i[0]) == null ? void 0 : r.code) === "ENER-";
    }
  ), l = {
    quantity_contained_kcal: a == null ? void 0 : a.quantity_contained,
    quantity_contained_kj: n == null ? void 0 : n.quantity_contained,
    daily_value_intake: (a == null ? void 0 : a.daily_value_intake_percent) || (n == null ? void 0 : n.daily_value_intake_percent),
    display_string: (a || n) && (f((E = (m = a == null ? void 0 : a.quantity_contained_uoms) == null ? void 0 : m[0]) == null ? void 0 : E.code) || f((d = (v = n == null ? void 0 : n.quantity_contained_uoms) == null ? void 0 : v[0]) == null ? void 0 : d.code)) ? `${R(
      Number(n == null ? void 0 : n.quantity_contained),
      (M = (F = n == null ? void 0 : n.quantity_contained_uoms) == null ? void 0 : F[0]) == null ? void 0 : M.code,
      c
    )} / ${R(
      Number(a == null ? void 0 : a.quantity_contained),
      ($ = (A = a == null ? void 0 : a.quantity_contained_uoms) == null ? void 0 : A[0]) == null ? void 0 : $.code,
      c
    )}` : "-"
  }, u = {
    quantity_contained_kcal: _ == null ? void 0 : _.quantity_contained,
    quantity_contained_kj: s == null ? void 0 : s.quantity_contained,
    daily_value_intake: ((_ == null ? void 0 : _.daily_value_intake_percent) || (s == null ? void 0 : s.daily_value_intake_percent)) ?? null,
    display_string: (_ || s) && (f((S = (k = _ == null ? void 0 : _.quantity_contained_uoms) == null ? void 0 : k[0]) == null ? void 0 : S.code) || f((b = (g = s == null ? void 0 : s.quantity_contained_uoms) == null ? void 0 : g[0]) == null ? void 0 : b.code)) ? `${R(
      Number(s == null ? void 0 : s.quantity_contained),
      (q = (h = s == null ? void 0 : s.quantity_contained_uoms) == null ? void 0 : h[0]) == null ? void 0 : q.code,
      c
    )} / ${R(
      Number(_ == null ? void 0 : _.quantity_contained),
      (I = (w = _ == null ? void 0 : _.quantity_contained_uoms) == null ? void 0 : w[0]) == null ? void 0 : I.code,
      c
    )}` : "-"
  };
  return {
    energyContentForDisplayPrepared: l,
    energyContentForDisplayUnprepared: u
  };
}, U = (t) => f(t) ? x[t] : t, K = (t, c) => t.includes("<") ? `${t}` : `${c}${t}`, R = (t, c, o) => {
  if (t !== null && !isNaN(t)) {
    if (t % 1 === 0)
      return `${t} ${U(c)}`;
    let e = t.toFixed(4).replace(/0+$/, "");
    return (!o || o === "fi" || o === "sv") && (e = e.replace(".", ",")), `${e} ${U(c)}`;
  }
  return "-";
}, p = (t, c) => {
  if (t !== null) {
    let o = Number(t) % 1 === 0 ? Number(t).toFixed(0) : Number(t).toFixed(1);
    return (!c || c === "fi" || c === "sv") && (o = o.replace(".", ",")), Number(o) !== 0 ? `${o} %` : "-";
  } else
    return "-";
};
function ee(t, c, o) {
  if (!t || t.length === 0)
    return;
  const e = t.find(
    (n) => n.language === c && o.every((s) => !!n[s])
  );
  return e || t.find(
    (n) => n.language === "fi" && o.every((s) => !!n[s])
  );
}
export {
  x as SI_UNITS,
  W as allContainmentsFreeFrom,
  Y as equalArrayOfStringsToRecord,
  p as formatDailyValueIntake,
  R as formatQuantityContained,
  K as formatQuantityContainedWithPrecision,
  U as formatSIUnit,
  J as getEnergyContentDisplayValue,
  ee as getLocalizedEntry,
  L as getMeasurementPrecision,
  Q as isNutrientSubset,
  f as isSIUnit,
  Z as transformActivities,
  X as transformAdditives,
  C as transformAllergens,
  D as transformBreadcrumbMap,
  G as transformFishingData,
  z as transformNutritionalClaims
};
